<div class="row pb-2" [ngClass]="{'justify-content-end': justifyContentRight}">

    <nb-radio-group
      name="budgetOrRatioFilter"
      class="filters-container"
      [(ngModel)]="budgetOrRatioFilter"
      (click)="budgetOrRatioFilterChanged()"
      >
      @for (option of budgetOrRatioFilterOptions; track option) {
        <nb-radio [value]="option.value">
          {{ option.label }}
        </nb-radio>
      }
    </nb-radio-group>

</div>
